import { api } from './base';

export interface SubscriberEmails {
  emails: Array<string>;
}

export const subscribeApis = {
  subscribe() {
    return api.post(`/subscriber`);
  },
  all_subscribers(): Promise<SubscriberEmails> {
    return api.get(`all_subscribers`).then(r => r.emails);
  }
};
